import { loader } from '@monaco-editor/react'

// Monaco's assets are copied to /static/monaco/min/vs at build time (see the
// CopyPlugin entry in config-overrides.js). Point @monaco-editor/react's loader
// at those locally-served assets instead of its default jsdelivr CDN, so every
// editor works in offline / network-restricted environments (e.g. air-gapped
// deploys or CI runners without outbound internet).
//
// loader.config is a global singleton that must run before the first <Editor>
// mounts. Importing this module once at the app entry (src/index.tsx)
// guarantees that — independent of which editor happens to mount first — Monaco
// is always loaded locally. Do NOT call loader.config from individual editor
// components; rely on this single configuration instead.
loader.config({ paths: { vs: '/static/monaco/min/vs' } })
